import { AdminSupportTicketDTO } from '../dtos/AdminSupportTickets.dto';
import { SupportTicketModel } from '../models/SupportTicket.model';
import { SupportTicketCommentUtil } from './SupportTicketCommentUtil';

export class SupportTicketUtil {
  public static mapToViewModel(dto: AdminSupportTicketDTO): SupportTicketModel {
    return {
      id: dto.id,
      communityDetails: {
        communityId: dto.communityId,
        community: dto.community.community,
        logo: dto.community.logo,
      },
      memberDetails: {
        memberId: dto.memberId,
        member: dto.member.fullName,
        email: dto.member.email,
        username: dto.member.username,
        scope: dto.member.scope,
      },
      ticket: dto.message,
      type: dto.type,
      postedOn: dto.timestamp,
      status: dto.status,
      appBuild: dto.build ? dto.build : null,
      deviceDetails: {
        os: dto.osType,
        osVersion: dto.osVersion ? dto.osVersion : null,
        device: dto.model ? dto.model : null,
        manufacturer: dto.manufacturer ? dto.manufacturer : null,
        network: dto.network ? dto.network : null,
        timezone: dto.timezone ? dto.timezone : null,
      },
      comments: dto.comments
        ? dto.comments.map((item) =>
            SupportTicketCommentUtil.mapToViewModel(item),
          )
        : [],
    };
  }
}
